// extracted by mini-css-extract-plugin
export default {"container":"Products_container__ZfWAm","products":"Products_products__ZlC3m","menu":"Products_menu__c0kv2","list":"Products_list__so9j-","product":"Products_product__TDFpr"};